export default function Close() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path
        d="M10.7571 8.26065L18.1941 0.823596L20.5558 3.18522L13.1187 10.6223L20.5551 18.0586L18.1948 20.4189L10.7585 12.9825L3.32142 20.4196L0.959798 18.0579L8.39685 10.6209L0.960488 3.18453L3.32073 0.824286L10.7571 8.26065Z"
        fill="white"
      />
      <title>Close</title>
    </svg>
  )
}
